import React from 'react'
import { Row, Col, Select, Form } from 'antd'

import DB2ISeriesRouteExecuteQry from './routes/db2-iseries-execute-qry'
import MemoryStore from '../../../../../utils/memory-store'

class DB2ISeriesRouteMain extends React.Component {
  constructor (props) {
    super(props)

    this.entry = MemoryStore.activeEntries[this.props.tabKey]

    this.state = {
      routeType: props.entry.routeData.routeType ? props.entry.routeData.routeType : ''
    }
  }

  onChangeRouteType (e) {
    this.entry.custom.isModifiedSubform = true
    this.setState({ routeType: e })
  }

  onFieldChange (key, value) {
    this.entry.custom.isModifiedSubform = true
    this.props.entry.routeData[key] = value
  }

  render () {
    return (
      <Row>
        <Col span={24}>
          <h3>Route Info</h3>
          <Form.Item>
            <span style={{ color: 'red' }}>* </span>Route Type
            <Select
              disabled={MemoryStore.userProfile.teamPrivileges.connectors === 'Reader'}
              defaultValue={this.state.routeType}
              onChange={e => {
                this.onChangeRouteType(e)
                this.onFieldChange('routeType', e)
              }}
            >
              <Select.Option value=''>-Select-</Select.Option>
              <Select.Option value='0'>Execute Query</Select.Option>
            </Select>
          </Form.Item>
          {this.state.routeType === '0' ? (
            <DB2ISeriesRouteExecuteQry entry={this.props.entry} tabKey={this.props.tabKey} />
          ) : null}
        </Col>
      </Row>
    )
  }
}

export default DB2ISeriesRouteMain
